import axios from "axios";
import { z } from "zod";
import { environment } from "../../../environment";
import { errorLog } from "../../../logger";
import { AltAssetId, DateSchema } from "../../Types";
import ValidationError from "../../ZodError";
export const assetTypes = [
    "Private Investment Holding",
    "Real Estate",
    "Crypto",
    "Collectable",
];
const AssetType = z.enum(assetTypes);
const AssetStatus = z.enum(["Active", "Sold"]);
const AlternativeAssetInfo = z.object({
    id: AltAssetId,
    personId: z.string(),
    assetName: z.string(),
    assetType: AssetType,
    assetValue: z
        .number()
        .nullable() // `null` value means `NaN` in the DB
        .transform((arg) => (arg === null ? 0 : arg)),
    assetStatus: AssetStatus,
    documentName: z.string().nullable(),
    createTime: DateSchema,
    modifyTime: DateSchema,
});
export const AltAssetPriceId = z.custom((val) => typeof val === "string");
const AltPrice = z.object({
    id: AltAssetPriceId,
    assetId: AltAssetId,
    assetValue: z
        .number()
        .nullable() // `null` value means `NaN` in the DB
        .transform((arg) => (arg === null ? 0 : arg)),
    createTime: DateSchema,
});
const AlternativeAsset = z.object({
    alt: AlternativeAssetInfo,
    altPrices: AltPrice.array(),
});
const Response = AlternativeAsset.array();
export const url = (clientId) => environment() === "PROD"
    ? `https://middleware.prod.farther.com/dashboard/client/${clientId}/alts`
    : `https://middleware.uat.farther.com/dashboard/client/${clientId}/alts`;
export default async function clientAltAssets(clientId, config) {
    const currentURL = url(clientId);
    const { data } = await axios.get(currentURL, {
        headers: {
            Authorization: `Bearer ${config.jwt}`,
            Client: config.clientId,
            ...(config.advisorId && { Advisor: config.advisorId }),
        },
    });
    const decoded = Response.safeParse(data);
    if (decoded.success) {
        return decoded.data;
    }
    else {
        const errorMessage = "[clientAltAssets] Could not parse";
        errorLog("clientAltAssets", `Could not parse, ${decoded.error.message}`);
        throw new ValidationError(errorMessage, decoded.error.issues);
    }
}
//# sourceMappingURL=getClientAlternativeAssets.js.map